<template>
  <a
    :href="`javascript:history.go(${go})`"
    aria-label="Back"
    class="btn btn-link"
  >
    <IconChevronLeft class="chevron"/>
    <slot></slot>
  </a>
</template>

<script>
import IconChevronLeft from '@/images/chevron-left.svg'

export default {
  name: 'BackButton',
  components: {
    IconChevronLeft,
  },
  props: {
    // FIXME: remove "to" and uses of it on BackButton if browser history technique sticks
    to: {
      type: String,
      default: '..',
    },
    go: {
      type: Number,
      default: -1,
    },
  },
}
</script>

<style lang="scss" scoped>
.chevron {
  width: 1em;
  height: 1em;
  transform: translate(0, -0.05em);
}
</style>
